import styles from './QuotaCheckModal.module.scss';
import { ReactComponent as AIIcon } from '../../assets/ai.svg';

interface BreakdownItemProps {
  value?: number;
  formattedValue: string | number;
  label: string;
}

export const BreakdownItem: React.FC<BreakdownItemProps> = ({ value, formattedValue, label }) => {
  if (!value || value <= 0) return null;

  return (
    <>
      <div className={styles.divider} />
      <div className={styles.quotaUsageDetail}>
        <div className={styles.detailLabel}>
          <AIIcon className={styles.aiIcon} />
          {label}
        </div>
        <div className={styles.detailValue}>{formattedValue}</div>
      </div>
    </>
  );
};
